// Returns a URL with query params appended (if any)
export function url(
	urlString: string,
	params?: Record<string, string>
): string {
	const urlObject = new URL(urlString)
	if (params) {
		Object.entries(params).forEach(([key, value]) => {
			urlObject.searchParams.append(key, value)
		})
	}
	return urlObject.href
}
